import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageTipService } from '../../../service/api/builk/image-tip.service';
import { ImageTipItemModel, ImageTipListQueryModel } from '../../../model/builk/image-tip/image-tip.model';
import { CreateNewCouponComponent } from '../coupon-setting/modals/create-new-coupon/create-new-coupon.component';
import { PageChangedEvent } from 'ngx-bootstrap';
import { VoucherService } from '../../../service/api/builk/voucher.service';
import { UpdateVoucherPackageModel, VoucherPackageItemModel, VoucherPackageListModel } from '../../../model/builk/voucher/voucher-list.model';
import { CreateVoucherComponent } from './modals/create-voucher/create-voucher.component';
import { SuccessModalComponent } from '../shared/success-modal/success-modal.component';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {
  @ViewChild("createVoucher") createVoucher: CreateVoucherComponent;//SuccessModalComponent
  @ViewChild("successModal") successModal: SuccessModalComponent;

  // boolean
  isLoading: boolean = false;

  // model
  queryModel: ImageTipListQueryModel = new ImageTipListQueryModel();
  voucherModel: VoucherPackageListModel = new VoucherPackageListModel();

  constructor(
    private voucherService: VoucherService
  ) { }

  ngOnInit() {
    this.initData();
    this.getVoucher();
  }

  initData() {
    //TODO
    this.queryModel.pageNumber = 1;
    this.queryModel.pageSize = 15;
    this.queryModel.sortByDesc = true;
    this.queryModel.sortColumn = 'VoucherSurrKey';
    this.queryModel.textSearch = '';
  }

  getVoucher() {
    this.isLoading = true;
    this.voucherService.getVoucher(this.queryModel).subscribe(res => {
      this.voucherModel = res;
      this.isLoading = false;
    });
  }

  openCreateVoucherModal() {
    this.createVoucher.openModal();
  }

  openEditVoucherModal(val: VoucherPackageItemModel) {
    this.createVoucher.edit(val);
  }

  isSaved(val: boolean) {
    if (val) {
      this.successModal.openSuccessModal(true, 'Success');
      this.getVoucher();
    }
  }

  onPageChange(event: PageChangedEvent) {
    this.queryModel.pageNumber = event.page;
    this.getVoucher();
  }

  getTime(dateTime: Date): string {
    const now = new Date(dateTime);
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onToggleActive(item: VoucherPackageItemModel) {
    let updateModel: UpdateVoucherPackageModel = {
      voucherPackageSurrKey: item.voucherSurrKey,
      voucherHeader: item.voucherHeader,
      voucherDetail: item.voucherDetail,
      file: null,
      voucherSalePrice: item.voucherSalePrice,
      voucherRedeemPrice: item.voucherRedeemPrice,
      product: item.product,
      descriptionUrl: item.descriptionUrl,
      userSurrKey: null,
      isActive: item.isActive,
    };

    this.voucherService.updateVoucherPackage(updateModel).subscribe(res => {
      if (res == true) {
        // alert('Success');
      } else {
        // alert('Failed');
      }
    })
  }

}
